import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import { ManagedSettingsDiagnosticSubmissionComponent } from './diagnostic-submission.component';

@Component({
  selector: 'ml-diagnostic-submission',
  templateUrl: './diagnostic-submission.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ManagedSettingsDiagnosticSubmissionComponent],
})
export class ManagedSettingsDiagnosticSubmissionContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  diagnosticSubmission(diagnosticSubmissionEnabled: boolean) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.diagnosticSubmission({
        udid: this.udid,
        enabled: diagnosticSubmissionEnabled,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
